import React from 'react';

/*
 * Pages that the new storefront now serves (Stage 2 of the rebuild).
 *
 * When someone clicks through to one of these inside this app, load the page
 * from the server instead of rendering the old component, so the new site
 * answers. If this app itself was loaded on that path (it was reached directly,
 * e.g. on its herokuapp.com address with no new site in front), show the old
 * page as before, which also rules out a reload loop.
 */
const firstPath = window.location.pathname;

const serverPage = (OldPage: React.ComponentType<any>) => (props: any) => {
  const { pathname, search, hash } = props.location;
  if (pathname === firstPath) return <OldPage {...props} />;
  window.location.assign(pathname + search + hash);
  return null;
};

export default serverPage;
